export default __webpack_public_path__ + "static/wall_street-092769a26b9d8945ce23bc27882f54ee.png";